import {h, Component} from 'preact';
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import Page from "../../../services/page-data-feed";

import SchedulesTimeFilter from "../utils/schedules-time-filter";
import * as M from "../desktop-templates/prematch-menu.jsx";


export default class MenuTimeFilter extends Component {
	setTimeFilter(value) {
		SchedulesTimeFilter.setTimeFilter(value);
		Page.rerender();
	}
	getButtons() {
		return [
			{value: SchedulesTimeFilter.FILTER_ALL, name: "All"},
			{value: SchedulesTimeFilter.FILTER_TODAY, name: "Today"},
			{value: SchedulesTimeFilter.FILTER_3HOUR, name: "3h"},
			{value: SchedulesTimeFilter.FILTER_6HOUR, name: "6h"},
			{value: SchedulesTimeFilter.FILTER_9HOUR, name: "9h"},
			{value: SchedulesTimeFilter.FILTER_12HOUR, name: "12h"},
		];
	}
	getCurrentFilter() {
		return SchedulesTimeFilter.getCurrentFilter();
	}
	render() {
		return <div>
			<M.MenuTitle><Trans>Quick Filter</Trans></M.MenuTitle>
			<M.TimeFilterButtonContainer>
				{this.getButtons().map(tab => (
					<M.TimeFilterButton 
					  onClick={e => {this.setTimeFilter(tab.value)}} 
					  active={this.getCurrentFilter() == tab.value}>
						{tab.name}
					</M.TimeFilterButton>
				))}
			</M.TimeFilterButtonContainer>
		</div>
	}
}